export default __webpack_public_path__ + "static/media/ssenkaabainterview.3ed2420c.png";